import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { checkoutLayoutRoutes } from './checkout-layout.routes';
import { localeGuard } from './guards/locale.guard';
import { mainLayoutRoutes } from './main-layout.routes';
import { LanguageService } from './services/language.service';

export const routes: Routes = [
  {
    path: 'contactInformation/cancel/:contact_information_id',
    loadComponent: () => import('./pages/contactinformation/cancel/cancel.page').then((m) => m.CancelPage),
  },
  {
    path: 'update-required',
    loadComponent: () => import('./pages/update-required/update-required.page').then((m) => m.UpdateRequiredPage),
  },
  {
    path: ':locale',
    canActivate: [localeGuard],
    children: [...checkoutLayoutRoutes, ...mainLayoutRoutes],
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: () => {
      const languageService = inject(LanguageService);
      return `${languageService.locale()}/home`;
    },
  },
  {
    path: '**',
    redirectTo: () => {
      const languageService = inject(LanguageService);
      return `${languageService.locale()}/home`;
    },
  },
];
